
import { computed, defineComponent, type PropType } from 'vue';
import type { ErrorObject } from '@vuelidate/core';

export type VuelidateValidation = {
    readonly $errors: ErrorObject[];
    readonly $touch: () => void;
};

export default defineComponent({
    name: 'AppError',
    props: {
        validations: {
            type: Object as PropType<VuelidateValidation>,
            default: undefined
        }
    },
    setup(props) {
        const errors = computed<ErrorObject[]>(() => props.validations?.$errors ?? []);

        return { errors };
    }
});
